import { router, Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export default function MoreLayout() {
  const { theme } = useStyles();

  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="profile"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="profile"
          options={{
            headerShown: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="bank-account"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="bank-account"
          options={{
            headerShown: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="locations"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="locations"
          options={{
            headerShown: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="support-faq/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="support-faq/index"
          options={{
            title: 'Support',
            headerTitle: 'Support',
            headerTitleAlign: 'center',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/partner/more');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="referrals/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="referrals/index"
          options={{
            title: 'Referral',
            headerTitle: 'Referral',
            headerTitleAlign: 'center',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/partner/more');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="submit-feedback/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="submit-feedback/index"
          options={{
            title: 'Submit Feedback',
            headerTitle: 'Submit Feedback',
            headerTitleAlign: 'center',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/partner/more');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="whats-new/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="whats-new/index"
          options={{
            title: "What's New",
            headerTitle: "What's New",
            headerTitleAlign: 'center',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/partner/more');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="legal/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="legal/index"
          options={{
            title: 'Legal',
            headerTitle: 'Legal',
            headerTitleAlign: 'center',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/partner/more');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="forgot-password"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="forgot-password"
          options={{
            title: 'Forgot Password',
            headerTitle: 'Forgot Password',
            headerLeft: () => <BackButton />,
            headerShown: false,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      <Stack.Screen
        name="confirm-phone"
        options={{
          title: 'Phone Number',
          headerShown: false,
        }}
      />
    </Stack>
  );
}
